import {
    AtribuirFaixasDistanciaInicial,
    AtribuirFaixasDistanciaModel,
    novaFaixaVazia,
} from "../models/atribuirFaixasDistanciaModel"
import {
    AtribuirFaixasDistanciaActionModel,
    AtribuirFaixasDistanciaActionsTypes,
} from "./atribuirFaixasDistanciaActions"

export function atribuirFaixasDistanciaReducer(
    state: AtribuirFaixasDistanciaModel,
    action: AtribuirFaixasDistanciaActionModel
): AtribuirFaixasDistanciaModel {
    switch (action.type) {
        case AtribuirFaixasDistanciaActionsTypes.CARREGAR:
            return action.payload

        case AtribuirFaixasDistanciaActionsTypes.ADICIONAR_FAIXA:
            return [...state, novaFaixaVazia(state.length)]

        case AtribuirFaixasDistanciaActionsTypes.ATUALIZAR_FAIXA: {
            const { index, campo, valor } = action.payload
            return state.map((faixa, i) =>
                i === index ? { ...faixa, [campo]: valor } : faixa
            )
        }

        case AtribuirFaixasDistanciaActionsTypes.REMOVER_FAIXA:
            return state.filter((_, i) => i !== action.payload.index)

        default:
            return state
    }
}
